import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

// Race-replay endpoints can take 1–3 minutes on a cold cache; we cap at 10
// minutes so a hung Python worker doesn't leave the page stuck on "loading"
// forever.
export const REPLAY_FETCH_TIMEOUT_MS = 10 * 60 * 1000;

// Combine multiple AbortSignals so a fetch aborts as soon as any of them
// fires. Used to merge TanStack Query's cancel signal (unmount, session
// change) with an explicit timeout signal.
export function anySignal(...signals: (AbortSignal | undefined)[]): AbortSignal {
  const controller = new AbortController();
  for (const signal of signals) {
    if (!signal) continue;
    if (signal.aborted) {
      controller.abort(signal.reason);
      return controller.signal;
    }
    signal.addEventListener("abort", () => controller.abort(signal.reason), { once: true });
  }
  return controller.signal;
}
